/*
 * Created by alex@hackerbay.com on 20.12.2018
 * Copyright Singularity Technologies GmbH (c) 2018. All rights reserved
 */

import * as React from "react";
import {translate} from "react-i18next";
import {Header} from "../../components/Header";
import TextBody from "../../components/TextBody";
import {Col, Container, Row} from "reactstrap";
import Subtitle from "../../components/Subtitle";
import SavePageButton from "../../components/SavePageButton";
import StatusBar from "../../components/StatusBar";
import BottomBarPassive from "../../components/BottomBarPassive";
import SideBarTechnicianInfo from "../../components/SideBarTechnicianInfo";
import {SpacerRow} from "../../components/SpacerRow";
import {BrowserView,MobileView,isMobile} from "react-device-detect";
import TopNav from "../../components/TopNav";
import HomescreenButton from "../../components/HomescreenButton";
import {
    MOMENT_TECHNICIAN_APPOINTMENT_DATE_FORMAT,
    MOMENT_TECHNICIAN_APPOINTMENT_DATE_FORMAT_DESKTOP,
    MOMENT_TECHNICIAN_APPOINTMENT_DATE_FORMAT_ONLY_WEEKDAY
} from "../../common";
import moment from "moment";
import {StatusBarDesktop} from "../../components/StatusBarDesktop";
import timeSlotFormatter from "../../timeSlotFormatter";
import technicianAppointmentRequired from "../../technicianRequired";
import vodafoneLogo from "../../media/icons/vf-logo.png";

class Stage5CurrentStatus extends React.Component {
    constructor(props){
        super(props);
    }

    render() {
        const timeSlot = this.props.ds360APIResult.appointmentTimeSlot;
        const timeSlotText = timeSlotFormatter(timeSlot).text;
        let date = this.props.ds360APIResult.selectedDate;
        if(date){
            //DSL API, initial date

        }else if(this.props.ds360APIResult.changedDate){
            //TT API changed date
            date = this.props.ds360APIResult.changedDate;
        }else{
            date = this.props.ds360APIResult.proposalDate;
        }
        const dateText = moment(date)
            .format(MOMENT_TECHNICIAN_APPOINTMENT_DATE_FORMAT_DESKTOP);

		/**
		 * Top Navigation / "Footer" Link
		 */
		const footerLnk = <TopNav
			buttonTextResource={"footer_link"}
			buttonOnClick={this.props.openTopNav}
		/>;

    /**
     * Top Navigation / "Footer" Link
     */
        const homescreenLnk = <HomescreenButton
        buttonTextResource={"Homescreen"}
        buttonOnClick={this.props.openHomeScreen}
    />;

        return <Container>
            <MobileView>
                <Row>
                    <Col xs={2} style={{marginTop:"15px"}}>
                        <img src={vodafoneLogo} className={"img-fluid"}  alt={"Vodafone Logo"}/>
                    </Col>
                    {footerLnk}
                </Row>
                <StatusBar
                    currentStage={this.props.currentStage}
                    technicianAppointmentRequired={technicianAppointmentRequired(this.props.ds360APIResult)}
                />
                <SpacerRow/>
                <Header
                    textResource={"checking_appointment_title"}
                />
                <SpacerRow/>
                <TextBody
                    textResource={"checking_appointment_change_notice_mobile"}
                />

                <span className={"fixed-to-bottom"} style={{positionX:"static"}}>

                <BottomBarPassive
                        dateText={dateText}
                        timeText={"time_o_clock"}
                        time={timeSlotText}
                    subText={"stage_5_appointment_pending_mobile"}
                />
            </span>
            </MobileView>
            <BrowserView>
                        <Row>
                        {footerLnk}
                        </Row>
                <StatusBarDesktop
                    currentStage={this.props.currentStage}
                    technicianAppointmentRequired={technicianAppointmentRequired(this.props.ds360APIResult)}
                />
                <Row>
                    <Col xs={7}  lg={{ size: 5, offset: 1 }} style={{marginTop:"12px"}}>
                        <Header
                            textResource={"checking_appointment_title"}
                        />
                        <SpacerRow/>
                        <TextBody
                            textResource={"checking_appointment_change_notice_desktop_1"}
                        />
                        <SpacerRow/>
                        <TextBody
                            textResource={"checking_appointment_change_notice_desktop_2"}
                        />
                        <SpacerRow/>

                    </Col>
                    <Col xs={5}  lg={{ size: 4, offset: 1 }} className={"round-corners shadow bg-white"}>

                        <SideBarTechnicianInfo
                            dateText={dateText}
                            timeText={"time_o_clock"}
                            time={timeSlotText}
                            subText={"stage_5_appointment_pending_desktop"}
                        />
                        <SpacerRow/>
                        <SpacerRow/>
                        <SpacerRow/>
                        <SpacerRow/>
                        <TextBody
                            textResource={"stage_5_appointment_description_desktop_1"}
                        />
                        <SpacerRow/>
                        <TextBody
                            textResource={"stage_5_appointment_description_desktop_2"}
                        />
                        <SpacerRow/>
                    </Col>
                </Row>
            </BrowserView>

        </Container>
    }
}

export default translate("translations")(Stage5CurrentStatus);
